// @flow
import { httpDelete, httpPost } from '../../helpers/helpers.api';

import Cookie from '<drivers>/cookie';
import url from 'url';

export function login(username: string, password: string, multiHomeEnabled: boolean = false): Promise<Response> {
    const loginURL = url.format({
        pathname: 'global/login'
    });

    const body = {
        username,
        password,
        devices: true,
        products: true,
        actions: true,
        homes: multiHomeEnabled
    };

    return httpPost(loginURL, body, false, false);
}

export function adminLogin(token: string, multiHomeEnabled: boolean = false): Promise<Response> {
    const body = {
        token: token,
        devices: true,
        products: true,
        actions: true,
        homes: multiHomeEnabled
    };

    const endpoint: string = Cookie.get('endpoint');
    const adminLoginURL: string = url.format({
        pathname: `${endpoint ? 'auth' : 'global'}/admin-login`
    });

    return httpPost(adminLoginURL, body, false, false, endpoint);
}

export function logout(): Promise<Response> {
    return httpDelete('auth/logout');
}



// WEBPACK FOOTER //
// ./src/core/api/authentication/auth/auth.api.js